export default __webpack_public_path__ + "static/media/success-input-icon.563ca6d5.svg";